export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/59690b7b-2a50-41a6-b17e-76616d8863bb/product-uploads/'

export const insideItems: string[] = [
  'Hand hygiene & the WHO 5 Moments',
  'PPE donning & doffing order',
  'Vital signs reference ranges',
  'Blood pressure technique & errors',
  'Safe transfers & positioning',
  'Pressure injury prevention',
  'Body-system anatomy diagrams',
  'Head-to-toe assessment sequence',
  'Heart & breath sound sites',
  'Glasgow Coma Scale',
  'Sterile field & sterile gloving',
  'Wound care & dressing change',
  'Urinary catheter care',
  'Oxygen delivery devices',
  'Peripheral IV fundamentals',
  'Infusion pumps',
  'Medication rights & label checks',
  'Injection angles & sites',
  'Dosage calculation formulas',
  'IV pump & drip rates',
  'Early warning signs',
  'Prioritization frameworks',
  'Basic Life Support & AED',
  'Postoperative care',
  '4-step skills demonstration',
  'Simulation scenarios & debriefing',
  'Competency checklists & rubrics',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
  'Skills lab exercises',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_8c70a5c5-4b8a-4988-b454-b1df9eb034ad_1793760797519.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 1 page: PPE Donning & Doffing Order, step-by-step putting on and removing gown, mask, goggles and gloves',
    title: 'Vol 1 — PPE Donning & Doffing Order',
    caption: 'Vol 1 — Nursing Fundamentals, Patient Care & Essential Clinical Skills: the donning and doffing sequence step by step, a common mistake and an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_3b87099c-a3a5-431d-bc80-7232e1ec6425_1793760800018.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 2 page: The Cardiovascular System, labeled heart anatomy and blood flow',
    title: 'Vol 2 — The Cardiovascular System',
    caption: 'Vol 2 — Human Anatomy, Health Assessment & Clinical Examination: labeled heart anatomy and blood flow, an instructor cue, a drill and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_4aea15ae-6fa9-452e-ab38-65a98a7ece5d_1793760802407.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 3 page: Oxygen Delivery Devices compared side by side',
    title: 'Vol 3 — Oxygen Delivery Devices',
    caption: 'Vol 3 — Nursing Procedures, Clinical Interventions & Patient Safety: oxygen delivery devices side by side, ❌/✅, an instructor cue and a skills-lab drill.',
  },
  {
    src: `${IMG_BASE}mcp_d3572ce5-b9a9-4510-a498-ebdf63bd0c03_1793760805151.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 4 page: IV Pump Rate (mL/h), formula, worked example and safe pump programming',
    title: 'Vol 4 — IV Pump Rate (mL/h)',
    caption: 'Vol 4 — Nursing Pharmacology, Medication Administration & Dosage Calculations: the mL/h formula with a worked example, a sanity check, safe pump programming and a quick check.',
  },
  {
    src: `${IMG_BASE}mcp_2ceb4775-f521-4292-9264-8ff29a35425a_1793760807640.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 5 page: Basic Life Support for adults, step-by-step sequence',
    title: 'Vol 5 — Basic Life Support',
    caption: 'Vol 5 — Medical-Surgical Nursing, Emergency Care & Clinical Decision-Making: the adult BLS sequence step by step, ❌/✅ and an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_1f9349d4-9e63-4c74-86a3-f4e507a4b962_1793760811040.jpg`,
    alt: 'Nursing Instructor Atlas — Vol 6 page: The 4-Step Skills Demonstration method for teaching any nursing skill',
    title: 'Vol 6 — The 4-Step Skills Demonstration',
    caption: 'Vol 6 — Nursing Instruction, Clinical Simulation & Competency Assessments: a 4-step sequence for teaching any nursing skill, an instructor cue and a return-demonstration drill.',
  },
]
